import { Card, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import CustomTooltip from "./CustomTooltip";

interface SubscriptionStatisticsTableProps {
    data: any;
}

const SubscriptionStatisticsTable = ({ data }: SubscriptionStatisticsTableProps) => {
    const { t } = useTranslation();

    if (!data) return null;

    const tableData = [
        {
            description: t("dashboard.monthlyRevenue"),
            value: data.currentMonthlyRevenue ? `€${data.currentMonthlyRevenue.toFixed(2)}` : "€0.00",
            tooltip: t("dashboard.tooltips.monthlyRevenue")
        },
        {
            description: t("dashboard.totalSubscriptions"),
            value: data.yearlyCloseToExpireSubscriptionData?.all || "0",
            tooltip: t("dashboard.tooltips.totalSubscriptions")
        },
        {
            description: t("dashboard.expiringSubscriptions"),
            value: data.yearlyCloseToExpireSubscriptionData?.expiring || "0",
            tooltip: t("dashboard.tooltips.expiringSubscriptions")
        },
        {
            description: t("dashboard.expiringPercentage"),
            value: data.yearlyCloseToExpireSubscriptionData?.percentOfExpiring ?
                `${data.yearlyCloseToExpireSubscriptionData.percentOfExpiring.toFixed(1)}%` : "0%",
            tooltip: t("dashboard.tooltips.expiringPercentage")
        }
    ];    // Add subscription overview data
    if (data.subscriptionOverview?.coach?.yearly) {
        const yearlyCoach = data.subscriptionOverview.coach.yearly.reduce((acc: any, item: any) => {
            if (acc[item.name]) {
                acc[item.name] += item.total;
            } else {
                acc[item.name] = item.total;
            }
            return acc;
        }, {});

        Object.entries(yearlyCoach).forEach(([name, total]) => {
            tableData.push({
                description: `${t("dashboard.yearlyCoach")} ${name}`,
                value: String(total),
                tooltip: t("dashboard.tooltips.yearlyCoachSubscription")
            });
        });
    }

    return (
        <Col md={6} className="my-3">
            <Card className="table-card h-100">
                <Card.Header>
                    <h5>{t("dashboard.subscriptionStatistics")}</h5>
                </Card.Header>
                <Card.Body className="py-3 px-0">
                    <div className="table-responsive">
                        <table className="table table-hover table-borderless mb-0">
                            <tbody>
                                {tableData.map((item, key) => (
                                    <tr key={key}>
                                        <td>
                                            <CustomTooltip text={item.tooltip}>
                                                <span className="text-muted">{item.description}</span>
                                            </CustomTooltip>
                                        </td>
                                        <td className="text-end f-w-600">{item.value}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};

export default SubscriptionStatisticsTable;
